import axios from 'axios'
import endpoints from '@/api/endpoints'
import _ from 'lodash'

export default {
  async getEquipmentForDivision (divID) {
    return axios.get(endpoints.equipment + '?division=' + divID).then((response) => {
      return _.orderBy(response.data, 'number')
    })
  },
  async getEquipment () {
    return axios.get(endpoints.equipment).then((response) => {
      return _.orderBy(response.data, 'number')
    })
  },
  async getEquipmentItem (itemID) {
    return axios.get(endpoints.equipment + itemID + '/').then((response) => {
      return response.data
    })
  },
  async updateEquipmentItem (item) {
    return axios.patch(endpoints.equipment + item.id + '/', item).then((response) => {
      return response.data
    })
  },
  async newEquipmentItem (item) {
    return axios.post(endpoints.equipment, item).then((response) => {
      return response.data
    })
  }
}
